import * as Sentry from '@sentry/react'

export { scrubSentryEvent } from '@cortado/observability'

export function newRequestId(): string {
  return globalThis.crypto?.randomUUID?.() ??
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

export function apiTraceTargets(apiUrl?: string): Array<string | RegExp> {
  const targets: Array<string | RegExp> = [
    'localhost',
    /^https:\/\/(?:[^/]+\.)?cortado\.pro/,
  ]
  if (apiUrl) {
    try {
      targets.push(new URL(apiUrl).origin)
    } catch {
      targets.push(apiUrl)
    }
  }
  return targets
}

export function recordResponseCorrelation(
  headers: Headers,
  span?: { setAttribute(key: string, value: string): unknown }
): { requestId?: string; traceId?: string } {
  const requestId = headers.get('X-Request-ID') || undefined
  const traceId = headers.get('X-Trace-ID') || undefined
  if (requestId) span?.setAttribute('server.request_id', requestId)
  if (traceId) span?.setAttribute('sentry.trace_id', traceId)
  if (requestId || traceId) {
    Sentry.addBreadcrumb({
      category: 'api.correlation',
      message: 'Backend response correlation',
      level: 'info',
      data: { requestId, traceId },
    })
  }
  return { requestId, traceId }
}
